import React, { Component } from 'react';

import TextField from '../form/TextField';
import AddressField from '../form/AddressField';
import PhoneField from '../form/PhoneField';
import SelectField from '../form/SelectField';
import EmailField from '../form/EmailField';

import JusticeField from './JusticeField';
import formStyles from '../form/Form.css';
import nationality from '../../shared/nationality.json';

class NaturalPersonField extends Component {
  render() {
    const { model, isAuthor } = this.props;

    return (
      <div>
        <SelectField
          inputProps={{
            clearable: false,
            options: [
              {
                label: 'Monsieur',
                value: 'M',
              },
              {
                label: 'Madame',
                value: 'F',
              },
            ],
          }}
          model={`${model}.gender`}
          label="Genre"
          required
        />

        <TextField
          model={`${model}.lastName`}
          label="Nom"
          required
        />

        <TextField
          model={`${model}.firstName`}
          label="Prénom"
          required
        />

        <TextField
          inputProps={{ type: 'date' }}
          model={`${model}.birthdate`}
          label="Date de naissance"
          required
        />

        <SelectField
          inputProps={{
            options: nationality,
          }}
          model={`${model}.nationality`}
          label="Nationalité"
          required
        />

        <AddressField
          model={`${model}.address`}
          label="Adresse"
          required
        />

        <EmailField
          model={`${model}.email`}
          label="Email"
          required
        />

        <PhoneField
          model={`${model}.phoneNumber`}
          label="Téléphone"
          required
        />

        <JusticeField isAuthor={isAuthor} model={model} />

        <div className={formStyles.title}>
          Documents justificatifs
        </div>

        <TextField
          inputProps={{
            type: 'file',
            accept: '.jpeg,.jpg,.png,.pdf',
          }}
          model={`${model}.idFile`}
          label="CNI/PASSEPORT (JPEG, PNG ou PDF)"
          required
        />
      </div>
    );
  }
}

export default NaturalPersonField;



/** WEBPACK FOOTER **
 ** ./client/act/NaturalPersonField.js
 **/